// extracted by mini-css-extract-plugin
export default {"iconDone":"order-details_iconDone__nz6DD","modalContainer":"order-details_modalContainer__zBFh7","blue":"order-details_blue__NLbIF"};